import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-spam-icon',
  templateUrl: './communication-spam.component.html'
})
export class CommunicationSpamComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
